var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.407,
    height: 19.176,
    viewBox: "0 0 19.407 19.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Upload_1157132",
    transform: "translate(21.108 15.288) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2760",
    "data-name": "Path 2760",
    d: "M20.124,56.077H2.663a.943.943,0,0,1-.963-.923V46.323a.943.943,0,0,1,.963-.923.93.93,0,0,1,.963.923v7.927H19.181V46.323a.943.943,0,0,1,.963-.923.93.93,0,0,1,.963.923v8.831A1,1,0,0,1,20.124,56.077Z",
    transform: "translate(22.808 52.188) rotate(180)",
    fill: "#3e2d2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2761",
    "data-name": "Path 2761",
    d: "M35.791,5.434,32.079,1.721a.97.97,0,0,0-1.345,0L26.981,5.434a.956.956,0,0,0-.281.682.91.91,0,0,0,.281.662.944.944,0,0,0,.662.281.956.956,0,0,0,.682-.281l2.047-2.027v9.533a1,1,0,0,0,2.007,0V4.711l2.067,2.067a.97.97,0,0,0,1.345,0,.944.944,0,0,0,.281-.662A.956.956,0,0,0,35.791,5.434Z",
    transform: "translate(-19.983 0)",
    fill: "#3e2d2e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.ca956402b8f6b4c3d384f326e6bcbc7a.svg";
export { ForwardRef as ReactComponent };